export const data = [
    {
        name: "Event 1",
        img: "https://images.freeimages.com/images/large-previews/d41/bear-combat-2-1332988.jpg",
    },
    {
        name: "Event 2",
        img: "https://images.freeimages.com/images/large-previews/d41/bear-combat-2-1332988.jpg",
    },
    {
        name: "Event 3",
        img: "https://images.freeimages.com/images/large-previews/d41/bear-combat-2-1332988.jpg",
    },
    {
        name: "Event 4",
        img: "https://images.freeimages.com/images/large-previews/d41/bear-combat-2-1332988.jpg",
    },
];